<mg-legacy-overlay-nav [component]="this"></mg-legacy-overlay-nav>
<div></div>
